class LoyaltyQuiz extends HTMLElement {
  constructor() {
    super();
    this.currentSlide = null;
    this.submitQuiz = this.querySelector(".loyalty_quiz-submit-btn");
    this.correctAnswers = {};
    this.selectedAnswers = {};
    this.pointsMap = {};
    this.resultSlide = this.querySelector(".loyalty_quiz-result");
    this.popupOverlay = this.querySelector(".loyalty_quiz-popup-overlay");
    this.section = this.querySelector(".loyalty_quiz-wrapper");
  }

  connectedCallback() {
    this.setPopup();
    this.getCorrectAnswers();
    this.getPointsMap();
    this.initButtonEvents(".loyalty_quiz-next-btn", "data-next");
    this.initButtonEvents(".loyalty_quiz-prev-btn", "data-prev");
    this.updateProgressBar(0);

    this.currentSlide = this.querySelector(".loyalty_quiz-block.active");
    this.totalQuestions = Object.keys(this.correctAnswers).length;

    this.submitQuiz.addEventListener("click", () => {
      if (this.currentSlide.querySelector("input[type='radio']:checked")) {
        this.showResult();
      } else {
        this.currentSlide.querySelector(".loyalty_quiz-error").classList.remove("hidden");
        setTimeout(() => {
          this.currentSlide.querySelector(".loyalty_quiz-error").classList.add("hidden");
        }, 3000);
      }
    });
  }

  setPopup() {
    const email = this.getAttribute("data-customer-email");
    const closeBtn = this.querySelector(".loyalty_quiz-popup-close-btn");

    const openPopup = async () => {
      if (!email){
        kpHandleLogin(window.location.href);
        return;
      }
      this.popupOverlay.classList.remove("hidden");
      document.body.style.overflow = "hidden";
      const loader = this.querySelector(".loyalty_quiz-loader");
      loader?.classList.remove("hidden");

      try {
        const data = await this.checkEmailExists(email);
        this.addEvents("Quiz_Started" , data);

        if (!data?.emailExists) return;

        const remainingTime = this.getRemainingTime(data.time);
        this.currentSlide.classList.remove("active");
        this.resultSlide.classList.add("active");

        const isSuccess = Number(data.correctAnswers) > 0;
        const resultDiv = this.resultSlide.querySelector(
          isSuccess
            ? ".loyalty_quiz_result-success"
            : ".loyalty_quiz_result-failure"
        );

        if (!resultDiv) return;

        resultDiv.classList.remove("hidden");

        const infoEl = resultDiv.querySelector(".loyalty_quiz-error-message-info");
        if (infoEl) {
          infoEl.classList.remove("hidden");
          infoEl.textContent = `Sorry, but you've already taken the quiz. You can play again after ${remainingTime} hours.`;
        }

        if (isSuccess) {
          const scoreEl = resultDiv.querySelector(".loyalty_quiz_result-success-score-value");
          const pointsEl = resultDiv.querySelector(".loyalty_quiz_result-success-points-value");
          if (scoreEl && pointsEl) {
            scoreEl.textContent = `${data.correctAnswers} / ${this.totalQuestions}`;
            pointsEl.textContent = `${data.points}`;
          }
        }
      } catch (err) {
        console.error("Error in openPopup:", err);
      } finally {
        loader?.classList.add("hidden");
      }
    };

    const closePopup = () => {
      this.popupOverlay.classList.add("hidden");
      document.body.style.overflow = "auto";
      this.resetQuiz();
    };

    this.section.addEventListener("click", openPopup);

    this.popupOverlay.addEventListener("click", (e) => {
      if (e.target === this.popupOverlay) closePopup();
    });

    if (closeBtn) {
      closeBtn.addEventListener("click", closePopup);
    }
  }

  initButtonEvents(selector, dataAttr) {
    this.querySelectorAll(selector).forEach((button) => {
      button.addEventListener("click", () => {
        const targetClass = button.getAttribute(dataAttr);
        const targetSlide = this.querySelector(`.${targetClass}`);
        if (!targetSlide) return;

        const radios = this.currentSlide.querySelectorAll("input[type='radio']");
        const hasRadio = radios.length > 0;
        const isRadioChecked = this.currentSlide.querySelector("input[type='radio']:checked");
        const errorBox = this.currentSlide.querySelector(".loyalty_quiz-error");

        if (selector === ".loyalty_quiz-next-btn" && this.currentSlide.getAttribute("data-index") != null) {
          this.addEvents("Question");
        }

        if (!hasRadio || selector === ".loyalty_quiz-prev-btn" || isRadioChecked ) {
          this.changeSlide(targetSlide);
          if (errorBox) errorBox.classList.add("hidden");
        } else if (errorBox) {
          errorBox.classList.remove("hidden");
          setTimeout(() => errorBox.classList.add("hidden"), 3000);
        }
      });
    });
  }

  changeSlide(newSlide) {
    if (!newSlide || newSlide === this.currentSlide) return;
    this.currentSlide?.classList.remove("active");
    newSlide.classList.add("active");
    this.currentSlide = newSlide;
    this.getSelectedAnswers();
    this.updateProgressBar(parseInt(newSlide.getAttribute("data-index")) || 0);
  }

  updateProgressBar(index) {
    const progressBar = this.querySelector(".loyalty_quiz-progress-bar-wrapper");
    const isFirst = index === 0;
    progressBar.classList.toggle("hidden", isFirst);

    if (!isFirst) {
      const progressBarFilled = this.querySelector(".loyalty_quiz-progress-bar-filled");
      const progressBarGoals = this.querySelectorAll(".loyalty_quiz-progress-bar-goals span");

      const progressPercent = ((index - 1) / (this.totalQuestions - 1)) * 100;
      progressBarFilled.style.width = `${progressPercent}%`;

      progressBarGoals.forEach((goal, i) => {
        goal.classList.toggle("filled", i < index);
      });
    }
  }

  getSelectedAnswers() {
    const radioInputs = this.querySelectorAll("input[type='radio']:checked");
    radioInputs.forEach((input) => {
      this.selectedAnswers[input.name] = input.value;
    });
  }

  getCorrectAnswers() {
    const jsonScript = this.querySelector("#loyalty-quiz-answers");
    if (jsonScript) {
      try {
        this.correctAnswers = JSON.parse(jsonScript.textContent);
      } catch (e) {
        console.error("Failed to parse correct answers JSON", e);
        this.correctAnswers = {};
      }
    }
  }

  getPointsMap() {
    const pointsRaw = this.getAttribute("data-loyalty-points");
    if (pointsRaw) {
      pointsRaw.split(",").forEach((pair) => {
        const [key, value] = pair.split("|").map((s) => s.trim());
        if (key && value) {
          this.pointsMap[key] = parseInt(value, 10);
        }
      });
    }
  }

  getRemainingTime(time) {
    const givenTime = new Date(time);
    const now = new Date();
    const twentyFourHours = 24 * 60 * 60 * 1000;

    const elapsed = now - givenTime;
    const remaining = Math.max(0, twentyFourHours - elapsed);

    return Math.ceil(remaining / (1000 * 60 * 60));
  }

  showResult() {
    this.updateProgressBar(0);
    this.getSelectedAnswers();

    const totalRightAnswers = Object.keys(this.correctAnswers).reduce(
      (count, key) =>
        this.selectedAnswers[key] === this.correctAnswers[key]
          ? count + 1
          : count,
      0
    );

    const points = this.pointsMap?.[totalRightAnswers] || 0;
    this.currentSlide.classList.remove("active");
    this.resultSlide.classList.add("active");
    this.addEvents('Quiz_Done',{points:points, score:totalRightAnswers})

    const successSection = this.resultSlide.querySelector(".loyalty_quiz_result-success");
    const failureSection = this.resultSlide.querySelector(".loyalty_quiz_result-failure");

    if (totalRightAnswers > 0) {
      successSection.classList.remove("hidden");

      const scoreValue = successSection.querySelector(".loyalty_quiz_result-success-score-value");
      const pointsValue = successSection.querySelector(".loyalty_quiz_result-success-points-value");
      if (scoreValue)
        scoreValue.textContent = `${totalRightAnswers}/${Object.keys(this.correctAnswers).length}`;
      if (pointsValue) pointsValue.textContent = `${points}`;
    } else {
      failureSection?.classList.remove("hidden");
    }
    this.submitForm(totalRightAnswers, points);
  }

  async submitForm(totalRightAnswers, points) {
    this.section.classList.add("disable")
    const formData = new FormData();
    formData.append("Name", this.getAttribute("data-customer-name") || "");
    formData.append("Email", this.getAttribute("data-customer-email") || "");
    formData.append("Mobile No", this.getAttribute("data-customer-phone") || "");
    formData.append("Correct Answers", totalRightAnswers);
    formData.append("Points", points);
    formData.append("Timestamp", new Date());

    try {
      const response = await fetch(
        "https://script.google.com/macros/s/AKfycbx9AF8pGSnZzLgci8R6Bf3gdrJw9ryHDqoEJ_ZMOYxkhZRzma_OWWABwSV-mF7HuYWmug/exec",
        {
          method: "POST",
          body: formData,
        }
      );

      if (!response.ok) {
        throw new Error("Failed to submit the form.");
      }
      console.log("Form successfully submitted.");
    } catch (error) {
      console.error("Submission error:", error);
    }
    finally{
      this.section.classList.remove("disable")
    }
  }

  async checkEmailExists(emailToCheck) {
    const sheetId = "1bUkdT4snWXRyh1mjzsG22-j6J0_GqYlcM6TAyOyt3M8";
    const apiKey = "AIzaSyDOjq27VFuGnznE1WOb55OEFmgcIui-o80";
    const sheetName = "Sheet1";

    const url = `https://sheets.googleapis.com/v4/spreadsheets/${sheetId}/values/${sheetName}?key=${apiKey}`;

    try {
      const response = await fetch(url);
      const data = await response.json();
      const rows = data.values || [];

      let result = {
        emailExists: false,
        correctAnswers: null,
        points: null,
      };

      for (const row of rows) {
        if (row[2] === emailToCheck) {
          result.emailExists = true;
          result.correctAnswers = row[4] || 0;
          result.points = row[5] || 0;
          result.time = row[6];
          break;
        }
      }

      return result;
    } catch (error) {
      console.error("Error accessing Google Sheet:", error);
      return {
        emailExists: false,
        correctAnswers: null,
        points: null,
      };
    }
  }

  resetQuiz() {
    this.querySelector(".loyalty_quiz-loader").classList.remove("hidden");
    this.querySelectorAll("input[type='radio']").forEach(radio => {
      radio.checked = false;
    });

    const slides = this.querySelectorAll(".loyalty_quiz-block");
    slides.forEach((slide, index) => {
      slide.classList.toggle("active", index === 0);
      if (index === 0) this.currentSlide = slide;
    });

    const successDiv = this.resultSlide.querySelector(".loyalty_quiz_result-success");
    const failureDiv = this.resultSlide.querySelector(".loyalty_quiz_result-failure");

    successDiv?.classList.add("hidden");
    failureDiv?.classList.add("hidden");

    this.querySelectorAll(".loyalty_quiz-error-message-info").forEach(item => {
      item.classList.add("hidden");
    });

    this.updateProgressBar(0);
  }

  addEvents(eventType, data){
    if (eventType == "Quiz_Started") {
      let clevertapData = {
        Banner_Image: this.section.querySelector(".loyalty_quiz-banner img").src || '',
        Last_Played: data.time || 'NA',
      }

      dataLayer.push({
        event: eventType,
        Banner_Image: this.section.querySelector(".loyalty_quiz-banner img").src || '',
        Last_Played: data.time || 'NA',
        clevertap: clevertapData
      });
    }
    else if (eventType == 'Question') {
      let clevertapData = {
        Question_No: this.currentSlide.getAttribute("data-index"),
        Correctect_Answer: this.correctAnswers[`loyalty_question_${this.currentSlide.getAttribute("data-index")}`] || 'NA',
        Users_Answer: this.currentSlide.querySelector("input[type='radio']:checked")?.value || '',
      }

      dataLayer.push({
        event: eventType,
        Question_No: this.currentSlide.getAttribute("data-index"),
        Correctect_Answer: this.correctAnswers[`loyalty_question_${this.currentSlide.getAttribute("data-index")}`] || 'NA',
        Users_Answer: this.currentSlide.querySelector("input[type='radio']:checked")?.value || '',
        clevertap: clevertapData
      });
    }
    else if ("Quiz_Done") {
      let clevertapData = {
        Total_Points_Earned: data.points,
        Score: data.score
      }

      dataLayer.push({
        event: eventType,
        Total_Points_Earned: data.points,
        Score: data.score,
        clevertap: clevertapData
      });
    }
  }
}

customElements.define("loyalty-quiz", LoyaltyQuiz);